// The Alerts doors' split, kept live: frames naming a workspace set it, else a re-read (split only).
import { client } from "./client.js";
import { activityState } from "../plugins/agents/state.svelte.js";
import { workspaceState } from "../core/state.svelte.js";
import { debounce } from "../utils.js";
import { reportUiFailure } from "../report-failure.js";

export const ALERT_SPLIT_DEBOUNCE_MS = 750;

// Bumped by every re-read and every other-workspace count: an older generation's answer is stale.
let generation = 0;

export async function refreshAlertSplit(): Promise<void> {
  const ws = workspaceState.current?.id;
  if (!ws || !client.connected) return;
  const mine = ++generation;
  try {
    const r = await client.fetchActivity(ws, { limit: 1 });
    if (mine !== generation || workspaceState.current?.id !== ws) return;
    activityState.setUnreadByWorkspace(r.unreadByWorkspace);
    activityState.setHiddenSplit(r.hiddenUnreadByWorkspace);
  } catch (err) {
    reportUiFailure("activity.splitRefresh", err, { workspaceId: ws });
  }
}

const reconcile = debounce(() => void refreshAlertSplit(), ALERT_SPLIT_DEBOUNCE_MS);

export function otherWorkspaceCountSet(): void {
  generation++;
}

// With one other workspace the door takes the live total, so only two or more need the split.
export function alertSplitChanged(): void {
  generation++;
  if (workspaceState.list.length > 2) reconcile();
}

// A channel of a workspace that is not open came back (app.svelte.ts notifyForIncoming): the hidden
// split is stale. Re-read only from a relay that sends it.
export function hiddenAlertsChanged(): void {
  if (activityState.knowsHiddenSplit) void refreshAlertSplit();
}
